export enum MessageFlavor {
  SHORT_TEXT = 'SHORT_TEXT',
  MAIL_PLAIN = 'MAIL_PLAIN',
  MAIL_HTML = 'MAIL_HTML',
}
